import isString from './is-string'

const isUrl = (link) => {
  if (!isString(link)) {
    return false
  }
  return link.startsWith('http')
}

export default isUrl
